import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  type?: string;
  className?: string;
  taskNumber?: number;
}

export const TaskName = ({ type, className, taskNumber }: Props) => {
  const { t } = useTranslation();

  const validTaskNumber = !isNaN(taskNumber as number);

  return (
    <div
      className={cn(
        'mr-[10px] !w-fit rounded-full bg-[#DCF0FF] px-[12px] py-[4px] text-[12px] font-bold uppercase text-[#4383F2] lg:text-[16px]',
        className,
      )}
    >
      {validTaskNumber && <span>{`${taskNumber}.`}</span>}

      {validTaskNumber && type ? type : t('exercise')}
    </div>
  );
};
